<script>
	import Timeline from './Timeline.svelte';

    let heading ={
        "title": "What I studied",
        "subtitle": "Education"
    }

  let details = [
        {
            "institution": "Busitema University, Uganda",
            "degree": "Bachelor of Science",
            "major": "Computer Engineering",
            "graduation": "2015",
        },
        {
            "institution": "Kawempe Muslim Secondary School, Uganda",
            "degree": "Uganda Advanced Certificate of Education",
            "major": "Physics, Chemistry, Mathematics and Entrepreneurship",
            "graduation": "2009",
        },
        {
          "institution": "Microverse, Remote-USA",
          "degree": "Software Engineering",
          "major": "Ruby on Rails, MERN Stack",
          "graduation": "2020",
        }
  ]

//   sort details by graduation recent to oldest
  details.sort((a, b) => {
    return new Date(b.graduation) - new Date(a.graduation);
  });


</script>

<Timeline timelineHeading={heading}  isEducation={true} timelineDetails={details} />